import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map, tap } from 'rxjs/operators';
import { Customer } from 'src/app/classes/customer.class';
import { ApiService } from './api/api.service';

export interface CustomerSearchParams {
    include_archived_projects?: boolean;
    include_customers_without_area?: boolean;
}

@Injectable({ providedIn: 'root' })
export class CustomerService {
    constructor(private apiService: ApiService) {}

    public getList(): Observable<Customer[]> {
        return this.apiService.getCallData$<Customer[]>('customers');
    }

    getSingle(id: number) {
        return this.apiService.getCallData$<Customer>(`customers/${id}`);
    }

    search(search = '', limit = 150, params: CustomerSearchParams = {}) {
        return this.apiService.getCallData$<Customer[]>(
            'customers',
            {
                search,
                limit,
                ...params,
            },
            { cache: true }
        );
    }

    public getPaginatedList(
        page: number,
        pageSize: number,
        search: string,
        onlyWithWork: boolean
    ): Observable<{ customers: Customer[]; total: number }> {
        return this.apiService.getCallData$<{ customers: Customer[]; total: number }>('customers/paginated', {
            page,
            per_page: pageSize,
            search,
            only_with_work: onlyWithWork,
        });
    }

    public show(id: number): Observable<Customer> {
        return this.apiService.getCallData$<Customer>(`customers/${id}/management`);
    }

    public create(customer: Partial<Customer>): Observable<Customer> {
        return this.apiService.postCall$<Customer>('customers', customer).pipe(
            map(response => response.data),
            tap(() => this.apiService.invalidateCache('customers'))
        );
    }

    public update(id: number, customer: Partial<Customer> & { user_ids?: number[] }): Observable<Customer> {
        return this.apiService.putCall$<Customer>(`customers/${id}`, customer).pipe(
            map(response => response.data),
            tap(() => this.apiService.invalidateCache('customers'))
        );
    }

    public delete(id: number): Observable<object> {
        return this.apiService
            .deleteCall$<object>(`customers/${id}`)
            .pipe(tap(() => this.apiService.invalidateCache('customers')));
    }
}
